import { render, staticRenderFns } from "./DispensaryItem.vue?vue&type=template&id=6e5b617d"
import script from "./DispensaryItem.vue?vue&type=script&lang=ts"
export * from "./DispensaryItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports